import { useHTTP, useHTTPQuery } from "@/lib/http";
import type { SpecialEmblemStatus } from "@/lib/domain/SpecialEmblemStatus";

export interface SpecialEmblemStatusModel {
	readonly status: SpecialEmblemStatus;
}

export const useSpecialEmblemStatus = (specialEmblemId: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["specialEmblemStatus", specialEmblemId],
		queryFn: () => http<SpecialEmblemStatusModel>({
			method: "GET",
			url: `/emblem/special/${specialEmblemId}/status`
		})
	});
};
